export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Blog", path: "/blog" },
  { label: "Contact Us", path: "/contact" },
];

export const FOOTER_LINKS = {
  "Quick Links": [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Blog", path: "/blog" },
    { label: "Contact Us", path: "/contact" },
  ],
  Services: [
    { label: "AI Development", path: "/services" },
    { label: "Web Development", path: "/services" },
    { label: "Mobile Apps", path: "/services" },
    { label: "Generative AI", path: "/services" },
    { label: "RAG Systems", path: "/services" },
    { label: "Enterprise Software", path: "/services" },
  ],
};

export const CONTACT_INFO = {
  email: "info@techindoglobal.cloud",
  phone: "+60 3 2637 3402",
  phoneE164: "+60326373402",
  address: "Kuala Lumpur, Malaysia",
  whatsapp: "60326373402",
};

export const SITE_META = {
  name: "Techindo Global",
  tagline: "Building smart, scalable tech solutions that drive innovation and transform businesses.",
};
